/**
 * Resolves to the given item in the path data.
 * For example, new DataHandler({}, 'foo', 'bar')
 * will return pathData.foo.bar.
 *
 * Resolution can optionally be async,
 * and/or be behind a function call.
 */
export default class DataHandler {
  constructor(options) {
    this._isAsync = options.async;
    this._isFunction = options.function;

    for (var _len = arguments.length, dataProperties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      dataProperties[_key - 1] = arguments[_key];
    }

    this._dataProperties = dataProperties;
  }

  static sync() {
    for (var _len2 = arguments.length, dataProperties = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dataProperties[_key2] = arguments[_key2];
    }

    return new DataHandler({
      async: false
    }, ...dataProperties);
  }

  static syncFunction() {
    for (var _len3 = arguments.length, dataProperties = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      dataProperties[_key3] = arguments[_key3];
    }

    return new DataHandler({
      async: false,
      function: true
    }, ...dataProperties);
  }

  static async() {
    for (var _len4 = arguments.length, dataProperties = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      dataProperties[_key4] = arguments[_key4];
    }

    return new DataHandler({
      async: true
    }, ...dataProperties);
  }

  static asyncFunction() {
    for (var _len5 = arguments.length, dataProperties = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      dataProperties[_key5] = arguments[_key5];
    }

    return new DataHandler({
      async: true,
      function: true
    }, ...dataProperties);
  } // Resolves the data path, or returns a function that does so


  handle(pathData) {
    return !this._isFunction ? this._resolveDataPath(pathData) : () => this._resolveDataPath(pathData);
  } // Resolves the data path


  _resolveDataPath(data) {
    return !this._isAsync ? this._resolveSyncDataPath(data) : this._resolveAsyncDataPath(data);
  } // Resolves synchronous property access


  _resolveSyncDataPath(data) {
    for (const property of this._dataProperties) data = data && data[property];

    return data;
  } // Resolves asynchronous property access


  async _resolveAsyncDataPath(data) {
    for (const property of this._dataProperties) data = data && (await data[property]);

    return data;
  }

}